var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('the-navbar'),_c('router-view',{staticStyle:{"padding-top":"66px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }